import { PDFDocument } from 'pdf-lib';

export function exportPdfWithAnnotations({
  downloadUrl,
  fileName,
  fabricRegistry,
  userFullName,
  mappers,
}) {
  if (!downloadUrl) {
    return Promise.reject(new Error('Missing PDF download URL'));
  }

  return fetch(downloadUrl)
    .then((res) => {
      if (!res.ok) {
        throw new Error('Failed to fetch PDF');
      }
      return res.arrayBuffer();
    })
    .then((pdfBytes) => PDFDocument.load(pdfBytes))
    .then((pdfDoc) => {
      Object.entries(fabricRegistry || {}).forEach(([pageNumber, canvas]) => {
        if (!canvas) return;

        const pageIndex = Number(pageNumber) - 1;
        const page = pdfDoc.getPage(pageIndex);

        const canvasWidth = canvas.getWidth?.();
        const canvasHeight = canvas.getHeight?.();

        // Commit textbox content before serialization/export.
        // canvas.getObjects().forEach((obj) => {
        //   if (obj?.objectType === 'textbox' && obj.isEditing) {
        //     obj.exitEditing();
        //     obj.setCoords?.();
        //   }
        // });

        canvas.getObjects().forEach((fabricObject) => {
          const mapper = mappers?.[fabricObject.objectType];

          if (!mapper) return;

          mapper({
            pdfDoc,
            page,
            fabricObject,
            basePageDimensions: {
              width: canvasWidth,
              height: canvasHeight,
            },
            user_full_name: userFullName,
          });
        });
      });

      return pdfDoc.save();
    })
    .then((newPdfBytes) => {
      const blob = new Blob([newPdfBytes], { type: 'application/pdf' });
      const url = URL.createObjectURL(blob);
      const a = document.createElement('a');

      a.href = url;
      a.download = `${fileName || 'annotated'}.pdf`;
      a.click();

      URL.revokeObjectURL(url);
      return newPdfBytes;
    });
}
